// extracted by mini-css-extract-plugin
module.exports = {"nav":"Employees_nav__i8C17","left":"Employees_left__3517g","right":"Employees_right__3SgZS"};